import { createBrowserRouter, Navigate } from 'react-router-dom'

import AppLayout from '@/layouts/AppLayout'
import AuthLayout from '@/layouts/AuthLayout'
import Dashboard from '@/pages/Dashboard'
import Users from '@/pages/Users'
import Transactions from '@/pages/Transactions'
import AccountSettings from '@/pages/AccountSettings'
import SignIn from '@/pages/auth/SignIn'
import ForgotPassword from '@/pages/auth/ForgotPassword'
import CreatePassword from '@/pages/auth/CreatePassword'
import { ProtectedRoute, PublicRoute } from './guards'
import TransactionSettings from '@/pages/TransactionSettings'
import InternalUsers from '@/pages/InternalUsers'
import FeatureFlags from '@/pages/FeatureFlags'

export const router = createBrowserRouter([
    {
        path: '/',
        element: <ProtectedRoute />,
        children: [
            {
                element: <AppLayout />,
                children: [
                    {
                        index: true,
                        element: <Dashboard />,
                    },
                    {
                        path: 'users',
                        element: <Users />,
                    },
                    {
                        path: 'internal-users',
                        element: <InternalUsers />,
                    },
                    {
                        path: 'transactions',
                        element: <Transactions />,
                    },
                    {
                        path: 'rates',
                        element: <TransactionSettings />,
                    },
                    {
                        path: 'feature-flags',
                        element: <FeatureFlags />,
                    },
                    {
                        path: 'account-settings',
                        element: <AccountSettings />,
                    },
                ],
            },
        ],
    },
    {
        path: '/auth',
        element: <PublicRoute />,
        children: [
            {
                element: <AuthLayout />,
                children: [
                    {
                        index: true,
                        element: <Navigate to="sign-in" replace />,
                    },
                    {
                        path: 'sign-in',
                        element: <SignIn />,
                    },
                    {
                        path: 'forgot-password',
                        element: <ForgotPassword />,
                    },
                    {
                        path: 'create-password',
                        element: <CreatePassword />,
                    },
                    {
                        path: 'reset-password',
                        element: <CreatePassword />,
                    },
                ],
            },
        ],
    },
    {
        path: '*',
        element: <Navigate to="/" replace />,
    },
])
